import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import {environment} from "../../../environments/environment";
import { ok } from 'assert';
import { threadId } from 'worker_threads';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  private currentAclSubject: Subject<ModelEventiCalamitosi.AclDto>;
  public currentAclObservable: Observable<ModelEventiCalamitosi.AclDto>;

  private aggiornaMenuSubject: Subject<boolean>;
  public aggiornaMenuObservable: Observable<boolean>;

  private currentUserAcl: BehaviorSubject<any>;
  public currentAcl: Observable<any>;

  public acl: string = '';

  constructor(private http: HttpClient) {
    this.currentUserSubject = new BehaviorSubject<any>(null);
    this.currentUser = this.currentUserSubject.asObservable();

    this.currentUserAcl = new BehaviorSubject<any>(null);
    this.currentAcl = this.currentUserAcl.asObservable();

    this.currentAclSubject = new Subject<ModelEventiCalamitosi.AclDto>();
    this.currentAclObservable = this.currentAclSubject.asObservable();

    this.aggiornaMenuSubject = new Subject<boolean>();
    this.aggiornaMenuObservable = this.aggiornaMenuSubject.asObservable();
  }


  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  login(acl : ModelEventiCalamitosi.AclDto) {
    this.currentAclSubject.next(acl);
    this.currentUserAcl.next(acl.acl);
    this.currentUserSubject.next(acl.ente);
    sessionStorage.setItem("acl", acl.acl);

    if (acl.nodeCode) {
      sessionStorage.setItem('officeCode', acl.nodeCode);
    }
  }

  public getAcl() {
    return this.http
      .get<ModelEventiCalamitosi.AclDto>(`${environment.urls.base}/utente/acl-utente`)
      .pipe(tap(acl => {
        //Salva l'ACL principale
        sessionStorage.setItem('acl', acl.acl);
        //Salva l'array di ruoli, convertendolo in una stringa JSON
        sessionStorage.setItem('ruoli', JSON.stringify(acl.ruoli));
        if (acl.nodeCode) {
          sessionStorage.setItem('officeCode', acl.nodeCode);
        }
        this.currentAclSubject.next(acl);
      }));
  }

  //Metodo per recuperare l'officeCode da sessionStorage
  public getOfficeCode(): string | null {
    return sessionStorage.getItem('officeCode');
  }

  public logout() {
    return this.http
      .get<any>(`${environment.urls.base}/utente/logout`)
      .pipe(map(ret => {
        this.currentUserSubject.next(null);
        this.currentUserAcl.next(null);
        this.currentAclSubject.next(null);
        sessionStorage.setItem("acl", "");
        sessionStorage.setItem("ruoli", "[]");
        sessionStorage.setItem("officeCode", "");
        return true;
      }));
  }


  public haveAcl(acl: string): boolean {
    const rolesString = sessionStorage.getItem('ruoli');
    if (rolesString) {
      try {
        const roles = JSON.parse(rolesString);
        if (roles.includes(acl)) {
          return true;
        }
      } catch (e) {
        console.error('Errore durante il parsing dei ruoli dalla sessionStorage', e);
      }
    }

    const mainAclString = sessionStorage.getItem('acl');
    if (mainAclString) {
      let arrayAcl = mainAclString.split(",");
      return arrayAcl.findIndex(el => el === acl) >= 0;
    }
    return false;
  }


  public aggiornaMenu() {
    this.aggiornaMenuSubject.next(true);
  }
}

